module.exports = __webpack_public_path__ + "img/AndroidDownload.a9d3b39e.png";